import { getDataFromLocalStorageParsed } from "./util";

export const STARLINK_TEMPLATE_NAMES = ["Starlink Access", "Starlink Admin Access", "Starlink Full Access"];
export const FULL_ACCESS = "Full Access";
export const LIMITED_ACCESS = "Limited Access";
export const READ_ACCESS = "Read Access";
export const PAUSE_LICENSE_ACCESS = "Pause License Access";
export const TRANSFER_LICENSE_ACCESS = "Transfer License Access";

export function filterTemplatesByCapability(allNames: string[], tosAccepted: boolean, starlinkOnly: boolean): string[] {
    const isStarlink = (name: string) => STARLINK_TEMPLATE_NAMES.includes(name);

    if (starlinkOnly) {
        return allNames.filter(isStarlink);
    }

    const sportNames = allNames.filter((name) => !isStarlink(name));
    const fullAccessIdx = sportNames.indexOf(FULL_ACCESS);
    if (fullAccessIdx > 0) {
        sportNames.splice(fullAccessIdx, 1);
        sportNames.unshift(FULL_ACCESS);
    }

    if (!tosAccepted) {
        return sportNames;
    }

    const starlinkNames = allNames.filter(isStarlink);
    return [...sportNames, ...starlinkNames];
}

export function isTemplateOptionDisabled(option: string, selected: string[]): boolean {
    if (STARLINK_TEMPLATE_NAMES.includes(option)) {
        return selected.some((s) => STARLINK_TEMPLATE_NAMES.includes(s) && s !== option);
    }

    if (option === LIMITED_ACCESS && selected.some((s) => s === FULL_ACCESS || s === READ_ACCESS || s === PAUSE_LICENSE_ACCESS || s === TRANSFER_LICENSE_ACCESS)) return true;
    if (option === FULL_ACCESS && selected.some((s) => s === LIMITED_ACCESS || s === READ_ACCESS)) return true;
    if (option === READ_ACCESS && selected.some((s) => s === LIMITED_ACCESS || s === FULL_ACCESS)) return true;
    if ((option === PAUSE_LICENSE_ACCESS || option === TRANSFER_LICENSE_ACCESS) && selected.some((s) => s === LIMITED_ACCESS)) return true;

    return false;
}

export function isStarlinkOnlyUser(): boolean {
    return getDataFromLocalStorageParsed("loggedInUser")?.data?.user?.starlinkOnlyUser === true;
}

export function splitTemplates(templateRecords: { name: string }[]): { sportNames: string[]; starlinkNames: string[] } {
    const allNames = templateRecords.map((t) => t.name);

    const sportNames = allNames.filter((name) => !STARLINK_TEMPLATE_NAMES.includes(name));
    const fullAccessIdx = sportNames.indexOf(FULL_ACCESS);
    if (fullAccessIdx > 0) {
        sportNames.splice(fullAccessIdx, 1);
        sportNames.unshift(FULL_ACCESS);
    }

    const starlinkNames = allNames.filter((name) => name.includes("Starlink"));

    return { sportNames, starlinkNames };
}
